type DefaultParticipants = {
    [key: string]: (number | string)[]
}

type ParticipantsFields = {
    [key: number]: string
}

export const getInitialParticipantsFromUrl = (
    searchParams: URLSearchParams,
    defaultParticipants: DefaultParticipants,
    participantsFields: ParticipantsFields,
) => {
    const qdt = parseInt(searchParams.get("qdt"))

    if (Number.isNaN(qdt) || !DjangIO.app.models.QuorumDataType.by_value(qdt)) {
        return defaultParticipants
    }

    const { [qdt]: participantsField } = participantsFields

    if (!participantsField) {
        return defaultParticipants
    }

    const value = searchParams.get("value")
    const [participant] = (value && value.split("/")) || []

    if (!participant) {
        return defaultParticipants
    }

    const parsedParticipant = Number.isNaN(parseInt(participant)) ? participant : parseInt(participant)

    return { ...defaultParticipants, [participantsField]: [parsedParticipant] }
}
